export type AppConfig = {
  apiPrefix: string;
  authenticatedEntryPath: string;
  unAuthenticatedEntryPath: string;
  locale: string;
  accessTokenPersistStrategy: "localStorage" | "sessionStorage" | "cookies";
  enableMock: boolean;
  activeNavTranslation: boolean;

  authenticatedAdminEntryPath: string;
  authenticatedControlpanelEntryPath: string;
  accessDeniedPath: string;
};

const appConfig: AppConfig = {
  apiPrefix: "/api",
  authenticatedEntryPath: "/",
  unAuthenticatedEntryPath: "/admin/sign-in",
  locale: "en-US", // NOT USED
  accessTokenPersistStrategy: "cookies",
  enableMock: false,
  activeNavTranslation: false,

  authenticatedAdminEntryPath: "/admin/home",
  authenticatedControlpanelEntryPath: "/admin/_cp/home",
  // Mounted by othersRoute.ts ("accessDenied", path "/access-denied") under
  // "/admin" (see OrganisationAllRoutes.tsx's "/admin" + route.path mapping).
  accessDeniedPath: "/admin/access-denied",
};

export default appConfig;
